import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b532f2b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "item-box"
};
const _hoisted_2 = {
  class: "item-li-p"
};
const _hoisted_3 = {
  class: "img-p"
};
const _hoisted_4 = {
  class: "img"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "nameP"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr hr30"
}, null, -1));
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "numP"
};
const _hoisted_11 = {
  key: 0,
  class: "numspan"
};
const _hoisted_12 = {
  key: 0,
  class: "btn-box"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_p"
}, null, -1));
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 1,
  class: "item-box"
};
const _hoisted_16 = {
  class: "item-li-p"
};
const _hoisted_17 = {
  class: "img-p"
};
const _hoisted_18 = {
  class: "img"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "content"
};
const _hoisted_21 = {
  class: "nameP"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr hr30"
}, null, -1));
const _hoisted_23 = {
  class: "titleP"
};
const _hoisted_24 = {
  class: "title"
};
const _hoisted_25 = {
  class: "numP"
};
const _hoisted_26 = {
  key: 0,
  class: "numspan"
};
const _hoisted_27 = {
  class: "shifu"
};
const _hoisted_28 = {
  class: "text_P"
};
const _hoisted_29 = {
  class: "pic_p"
};
const _hoisted_30 = {
  key: 0,
  class: "btn-box"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_p"
}, null, -1));
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  key: 2,
  class: "item-box"
};
const _hoisted_34 = {
  class: "item-li"
};
const _hoisted_35 = {
  class: "sku-box"
};
const _hoisted_36 = {
  class: "img pro"
};
const _hoisted_37 = ["src"];
const _hoisted_38 = {
  class: "content"
};
const _hoisted_39 = {
  class: "content-left"
};
const _hoisted_40 = {
  class: "name"
};
const _hoisted_41 = {
  key: 0,
  class: "yushou"
};
const _hoisted_42 = {
  key: 0,
  class: "tips"
};
const _hoisted_43 = {
  class: "price"
};
const _hoisted_44 = {
  class: "p"
};
const _hoisted_45 = {
  class: "num"
};
const _hoisted_46 = {
  class: "img pro"
};
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  class: "content"
};
const _hoisted_49 = {
  class: "content-left"
};
const _hoisted_50 = {
  class: "name"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tedian"
}, "特典", -1));
const _hoisted_52 = {
  key: 0,
  class: "tips"
};
const _hoisted_53 = {
  class: "price"
};
const _hoisted_54 = {
  class: "p"
};
const _hoisted_55 = {
  class: "num"
};
const _hoisted_56 = {
  class: "shifu"
};
const _hoisted_57 = {
  class: "text_P"
};
const _hoisted_58 = {
  class: "pic_p"
};
const _hoisted_59 = {
  key: 0,
  class: "btn-box"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_p"
}, null, -1));
const _hoisted_61 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_itemlititle = _resolveComponent("itemlititle");
  return _openBlock(), _createElementBlock("div", {
    class: "li",
    onClick: _cache[3] || (_cache[3] = $event => $options.gotoDetails({
      item: $props.item
    }))
  }, [_createVNode(_component_itemlititle, {
    item: $props.item,
    onJumpShop: $options.jumpShop,
    nav: $props.nav
  }, null, 8, ["item", "onJumpShop", "nav"]), this.nav == 200 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: _ctx.$imgUrlFilter($props.item.info.logo, $options.imgWidth),
    alt: ""
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($props.item.info.name), 1)])]), $props.nav == 200 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.info.items, (rewardItem, rewardIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "titleP",
      key: rewardIndex
    }, [_createElementVNode("div", _hoisted_9, _toDisplayString(rewardItem.title), 1), _createElementVNode("div", _hoisted_10, [rewardItem.num ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(rewardItem.num), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(rewardItem.price), 1)])]);
  }), 128))], 64)) : _createCommentVNode("", true)]), $props.item.btn_list && $props.item.btn_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, $props.item.btn_list.length > 2 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "span",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.show_dialog({
      arr: $props.item.btn_list,
      id: $props.item.order_id,
      item: $props.item,
      type: ''
    }), ["stop"]))
  }, "更多")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.btn_list, (data, ix) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [ix + 3 > $props.item.btn_list.length ? (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['btn', data.type]),
      key: ix,
      onClick: _withModifiers($event => $options.op({
        type: data.type,
        item: $props.item,
        orderType: 'object',
        data
      }), ["stop"])
    }, _toDisplayString(data.title), 11, _hoisted_14)) : _createCommentVNode("", true)], 64);
  }), 256))])) : _createCommentVNode("", true)])) : $props.item.order_type != 4 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
    src: _ctx.$imgUrlFilter($props.item.pro.product_info.logo, $options.imgWidth),
    alt: ""
  }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString($props.item.pro.product_info.name), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.pro.pay_items, (items, ix) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: ix
    }, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(items.item_title), 1), _createElementVNode("div", _hoisted_25, [items.total ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(items.total), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(items.price), 1)])])], 64);
  }), 128))]), _createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, _toDisplayString($props.item.total_amount_title), 1), _createElementVNode("span", _hoisted_29, _toDisplayString($props.item.total_amount_value), 1)]), $props.item.status_data && $props.item.status_data.btn_list && $props.item.status_data.btn_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, $props.item.status_data.btn_list.length > 2 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "span",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.show_dialog({
      arr: $props.item.status_data.btn_list,
      id: $props.item.order_id,
      item: $props.item,
      type: ''
    }), ["stop"]))
  }, " 更多 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.status_data.btn_list, (data, ix) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [ix + 3 > $props.item.status_data.btn_list.length ? (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['btn', data.type]),
      key: ix,
      onClick: _withModifiers($event => $options.op({
        type: data.type,
        item: $props.item,
        orderType: 'object'
      }), ["stop"])
    }, _toDisplayString(data.title), 11, _hoisted_32)) : _createCommentVNode("", true)], 64);
  }), 256))])) : _createCommentVNode("", true)])) : $props.item.mall && $props.item.mall.shop_info ? (_openBlock(), _createElementBlock("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.mall.shop_info.skus, (e, ix) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item-ul",
      key: ix
    }, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("img", {
      src: _ctx.$imgUrlFilter(e.product_img, $options.imgWidth),
      alt: ""
    }, null, 8, _hoisted_37)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [e.presale_type != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(e.product_name), 1)]), _createElementVNode("p", null, _toDisplayString(e.sku_specs), 1), e.presale_type != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(e.deliver_forecast_time), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, "¥ " + _toDisplayString(e.sku_price), 1), _createElementVNode("div", _hoisted_45, "x " + _toDisplayString(e.num), 1)])])]), e.gifts && e.gifts.length ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList(e.gifts, (e, ix) => {
      return _openBlock(), _createElementBlock("div", {
        class: "gift-box",
        key: ix
      }, [_createElementVNode("div", _hoisted_46, [_createElementVNode("img", {
        src: _ctx.$imgUrlFilter(e.product_img, $options.imgWidth),
        alt: ""
      }, null, 8, _hoisted_47)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_hoisted_51, _createTextVNode(" " + _toDisplayString(e.product_name), 1)]), _createElementVNode("p", null, _toDisplayString(e.sku_specs), 1), e.presale_type != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(e.deliver_forecast_time), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, "¥" + _toDisplayString(e.sku_price), 1), _createElementVNode("div", _hoisted_55, "x" + _toDisplayString(e.num), 1)])])]);
    }), 128)) : _createCommentVNode("", true)])]);
  }), 128)), _createElementVNode("div", _hoisted_56, [_createElementVNode("span", _hoisted_57, _toDisplayString($props.item.total_amount_title), 1), _createElementVNode("span", _hoisted_58, _toDisplayString($props.item.total_amount_value), 1)]), $props.item.status_data && $props.item.status_data.btn_list && $props.item.status_data.btn_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_hoisted_60, $props.item.status_data.btn_list.length > 2 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "span",
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.show_dialog({
      arr: $props.item.status_data.btn_list,
      id: $props.item.order_id,
      item: $props.item,
      type: ''
    }), ["stop"]))
  }, " 更多 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.status_data.btn_list, (data, ix) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [ix + 3 > $props.item.status_data.btn_list.length ? (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['btn', data.type]),
      key: ix,
      onClick: _withModifiers($event => $options.op({
        type: data.type,
        item: $props.item,
        orderType: ''
      }), ["stop"])
    }, _toDisplayString(data.title), 11, _hoisted_61)) : _createCommentVNode("", true)], 64);
  }), 256))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}